<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" class="py-16" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px;">
        <v-img src="@/assets/emergency_20250117.png"></v-img>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'EmergencyContactView',
  components: {
    Title,
  },
  data() {
    return {
      title: '緊急連絡体制',
      img: 'title_emergencyContact.svg',
    };
  },
};
</script>

<style scoped lang="scss">
</style>